module.exports = "<div class=\"row\">\n  <app-queue-item *ngFor=\"let channel of channels\" [model]=channel class=\"col-xs-3\"></app-queue-item>\n</div>\n\n\n<app-admin-controls (onChannelSelected)=\"nextQueue($event)\" [channelCount]=channels.length></app-admin-controls>\n{{channel}}"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/layout.component.html
// module id = 168
// module chunks = 1